import Vuex from 'vuex'
import Vue from 'vue'
 
Vue.use(Vuex)
 
// 响应组件中的动作
const actions = {}
 
// 操作数据（state）
const mutations = {
    getLogin(state,islogin){
        state.islogin=islogin
    },
    getRegister(state,isregister){
        state.isregister=isregister
    },
    getService(state,isService){
        state.isService=isService
    },
    getHouseCampaign(state,isHouseCampaign){
        state.isHouseCampaign=isHouseCampaign
    },
}
 
// 用于存储数据
const state = {
    nav:[], //导航栏
    islogin:false,
    isregister:false,
    isService:false,
    isHouseCampaign:false,
    token:'',
}
 
// 创建store
const store = new Vuex.Store({
    actions,
    mutations,
    state
})

export default store